import classNames from 'classnames';
import * as React from 'react';
import { BorderRadiusProps } from '../../../@types/theme';

import styles from './ProgressBar.module.scss';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  steps: number;
  currentStep: number;
  label?: string;
  height?: string;
  width?: string;
  radius?: Omit<BorderRadiusProps, 'rounded'> | '0';
}

export const ProgressBar: React.FunctionComponent<Props> = ({
  className,
  style,
  steps,
  currentStep,
  label = 'Barra de progresso',
  height = '0.5rem',
  width = '100%',
  radius = 'sm',
  ...htmlElementProps
}) => {
  const currentPercentage = Math.round((currentStep / steps) * 100);
  return (
    <div
      className={classNames(styles.wrapper, `rounded-${radius}`, className)}
      style={{ ...style, height, width }}
      role="progressbar"
      aria-valuenow={currentPercentage}
      aria-label={label}
      {...htmlElementProps}
    >
      <div className={classNames(styles.track, `rounded-${radius}`)}>
        <div
          className={classNames(styles.inner, `rounded-${radius}`)}
          style={{ width: `${currentPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
